import React from 'react'
import PropTypes from 'prop-types'
import { Input } from 'antd'
import { Controller } from 'react-hook-form'

import styles from '../index.module.scss'
import { StyledFormItem } from '../styles'

const TextAreaForm = ({
	name,
	label,
	control,
	required = false,
	...fieldProps
}) => {
	return (
		<StyledFormItem required={required}>
			<p className={styles.label}>
				{label} {required && <span style={{ color: 'red' }}>*</span>}
			</p>
			<Controller
				name={name}
				control={control}
				rules={{
					required: required ? `O campo ${label} é obrigatório` : false,
				}}
				render={({ field, fieldState }) => (
					<>
						<Input.TextArea
							{...field}
							{...fieldProps}
							autoSize={{ minRows: 3 }}
							onChange={(value) => field.onChange(value)}
						/>

						{fieldState.error && (
							<span className={styles.errorMessage}>
								{fieldState.error.message}
							</span>
						)}
					</>
				)}
			/>
		</StyledFormItem>
	)
}

TextAreaForm.propTypes = {
	name: PropTypes.string,
	label: PropTypes.string,
	control: PropTypes.object,
	required: PropTypes.bool,
	fieldProps: PropTypes.object,
}

export default TextAreaForm
